import React, { useCallback, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import PaymentsService from '../../services/payments.service'
import { getAccountListSelector, getMenuListSelector } from '../../store/selectors/app.selector'
import { MENU_NAMES_ICONS_KEYS } from '../../utils/translation-constants'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import { TRANSFER_MENUS } from '../Layout/menu-names'

export default function Transfers() {
  const history = useHistory()
  const accounts = useSelector(getAccountListSelector) || []
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['TRANSFER'] || {}
  const [billerList, setBillerList] = useState([])

  useEffect(() => {
    // getBillProducts()
  }, [])

  // const getBillProducts = useCallback(async () => {
  //   try {
  //     const response = await PaymentsService.getAllBillers({
  //       fetchServices: false,
  //       fetchProducts: false,
  //       module: 'TRANSFER',
  //     })
  //     if (response.status === 200) {
  //       response.data['categories'].forEach((element) => {
  //         element.title = element.category
  //         element.icon = null
  //         element.key = element.category
  //       })
  //       setBillerList(response.data['categories'])
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }, [])



  return (
    <LayoutWithAccountCard breadCumKey='TRANSFERS'>
      <Row>
        {Object.keys(menuConfig).length > 0 &&
          TRANSFER_MENUS.map((option, index) => (
            <>
              {menuConfig[option.key] && (
                <Col
                  onClick={() => (accounts.length > 0 ? history.push(option?.link) : '')}
                  xs={'auto'}
                  sm={'auto'}
                  md={'auto'}
                  key={index}
                  className='account-menu-card'>
                  <img width={52} height={40} src={option.icon} />
                  <h2>{t(option.title)}</h2>
                  <span>{t(option.desc)}</span>
                </Col>
              )}
            </>
          ))}

        {/* <Col
          xs={'auto'}
          sm={'auto'}
          md={'auto'}
          onClick={() => history.push('/cardLessCash')}
          className='account-menu-card'>
          <img width={52} height={40} src={null} />
          <h2>{t(MENU_NAMES_ICONS_KEYS.CARD_LESS_CASH)}</h2>
          <span>{''}</span>
        </Col> */}

        {/* {billerList.map((option, index) => (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() =>
              accounts.length > 0
                ? history.push({
                    pathname: '/transfers/servicesView',
                    state: { categoryDetails: option },
                  })
                : ''
            }>
            <img width={52} height={40} src={option?.icon} />
            <h2>{t(option?.description)}</h2>
            <span>{t(option.title)}</span>
          </Col>
        ))} */}


      </Row>
    </LayoutWithAccountCard>
  )
}